import React from 'react'
import PropTypes from 'prop-types'
import { Popup } from 'semantic-ui-react'

export const DescriptionPopupWithoutIcon = ({
  children,
  style,
  trigger,
  basic,
  open,
  onOpen,
  onClose,
  position,
  on,
}) => (
  <Popup
    hoverable
    on={on}
    open={open}
    onOpen={onOpen}
    onClose={onClose}
    trigger={trigger}
    content={children}
    className="wide"
    style={style}
    basic={basic}
    position={position}
  />
)

DescriptionPopupWithoutIcon.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.string,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DescriptionPopupWithoutIcon.js